import { openBlock as r, createElementBlock as l, createElementVNode as n, toDisplayString as a } from "vue";
const p = (e, s) => {
  const o = e.__vccOpts || e;
  for (const [i, t] of s)
    o[i] = t;
  return o;
}, c = {
  name: "AriaAnnouncer",
  props: {
    politeness: {
      type: String,
      required: !1,
      default: "polite"
    },
    message: {
      type: String,
      required: !1,
      default: ""
    }
  },
  data() {
    return {
      box1: {
        message: "",
        politeness: "polite"
      },
      box2: {
        message: "",
        politeness: "polite"
      },
      box: "1"
    };
  },
  beforeUpdate() {
    this.message && this.swapBox(this.box);
  },
  methods: {
    clearBox(e) {
      this[`box${e}`].politeness = "polite", this[`box${e}`].message = "";
    },
    updateBox(e) {
      this[`box${e}`].politeness = this.politeness, this[`box${e}`].message = this.message;
    },
    swapBox(e) {
      const s = e === "1" ? "2" : "1";
      this.updateBox(e), this.clearBox(s), this.box = s;
    }
  }
}, x = ["data-message"], m = ["aria-live", "textContent"], h = ["aria-live", "textContent"];
function d(e, s, o, i, t, g) {
  return r(), l("div", {
    "data-message": o.message
  }, [n("p", {
    "aria-live": t.box1.politeness,
    textContent: a(t.box1.message)
  }, null, 8, m), n("p", {
    "aria-live": t.box2.politeness,
    textContent: a(t.box2.message)
  }, null, 8, h)], 8, x);
}
const _ = /* @__PURE__ */ p(c, [["render", d]]);
export {
  _ as default
};
